import { AllStatusEnums, EClusterStatus, EValidatorStatus, StatusMapper, ValidationStatusMapper } from '../entities/IGlobal';

export const getStatus = (status: AllStatusEnums) => {
    return StatusMapper.find(value => value.key === status);
};

export const getStatusColor = (status: AllStatusEnums) => {
    return StatusMapper.find(value => value.key === status)?.data.color || '';
};

export const getStatusFontColor = (status: AllStatusEnums) => {
    return StatusMapper.find(value => value.key === status)?.data.fontColor || '';
};

export const getStatusText = (status: AllStatusEnums, intlFormatMessage: any) => {
    return StatusMapper.find(value => value.key === status)?.text ? (intlFormatMessage?.formatMessage || intlFormatMessage)({id: StatusMapper.find(value => value.key === status)?.text}) : '';
};

const clusterStatusNumericOrder: EClusterStatus[] = [EClusterStatus.Active, EClusterStatus.Closed, EClusterStatus.Archived];

export const getEditableClusterStatuses = (archivizationEnabled: boolean): EClusterStatus[] =>
    archivizationEnabled
        ? [EClusterStatus.Active, EClusterStatus.Closed, EClusterStatus.Archived]
        : [EClusterStatus.Active, EClusterStatus.Closed];

export const normalizeClusterPresentationStatus = (raw: unknown): EClusterStatus => {
    if (typeof raw === 'number' && Number.isInteger(raw) && raw >= 0 && raw <= 2) {
        return clusterStatusNumericOrder[raw];
    }
    if (Object.values(EClusterStatus).includes(raw as EClusterStatus)) {
        return raw as EClusterStatus;
    }
    return EClusterStatus.Active;
};

export const getValidationBackground = (status: EValidatorStatus) => {
    return ValidationStatusMapper.find(value => value.key === status)?.data.color || '';
};